// App.tsx
import React from "react";
import { useSearchParams } from "react-router-dom";
import { DynamicForm } from "../components/DynamicForm";
import { INCOTERM_OPTIONS } from "../config/formConfig";
import Dropdown from "../components/DropDown";
import taramLogoFull from "../assets/icons/TaramFullLogo.png";
import InvalidLinkPage from "../pages/InvalidLinkPage";

// import { schemaForSheet } from '../config/formConfig';

export default function CustomQutoesLayout() {
  const [incoterm, setIncoterm] = React.useState<
    (typeof INCOTERM_OPTIONS)[number] | ""
  >("");
    const [searchParams] = useSearchParams();
  const hash_id = searchParams.get('hash_id');

    if (!hash_id) return <InvalidLinkPage />;
  return (
    <section className="w-full p-2 md:p-10 bg-custom-off-white">
      <div className="max-w-[700px] mx-auto">
        <div className="flex justify-between items-center mb-2 text-gray-800">
          <div>
            <img
              src={taramLogoFull}
              alt="logo"
              width={100}
              height={20}
              className="full_logo"
            />
            <h2 className="font-medium">Please Select you Incoterm</h2>
          </div>
          <div className="w-1/2">
            <Dropdown
              label={"Select Incoterm/Sheet"}
              options={INCOTERM_OPTIONS.map((op) => ({ label: op, value: op }))}
              value={incoterm}
              onChange={(e) => setIncoterm(e.currentTarget.value as any)}
            />
          </div>
        </div>

        <DynamicForm hash_id={hash_id} incoterm={incoterm} onSubmitData={() => {}} />
      </div>
    </section>
  );
}
